export const formatUserDisplayName = (
  firstName: string | null,
  lastName: string | null,
  userId: string | null
): string => {
  // If we have first name and last name, format as "FirstName L."
  if (firstName && lastName) {
    return `${firstName} ${lastName.charAt(0).toUpperCase()}.`;
  }
  
  // If we only have first name, use just that
  if (firstName) {
    return firstName;
  }
  
  // If we only have last name, use just that
  if (lastName) {
    return lastName;
  }
  
  // Fallback to anonymous if no user ID or names
  if (!userId) {
    return "Anonymous User";
  }
  
  // Generate consistent initials from user ID as last resort
  const chars = userId.replace(/-/g, '').toUpperCase();
  return `User ${chars.slice(0, 2)}`;
};

export const formatFirstNameForWelcome = (firstName: string | null): string => {
  if (!firstName) return "User";
  
  // Capitalize first letter and keep the rest as is
  return firstName.charAt(0).toUpperCase() + firstName.slice(1);
};

export const getInitials = (
  firstName: string | null,
  lastName: string | null,
  userId: string | null
): string => {
  if (firstName && lastName) {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  }
  
  if (firstName) {
    return firstName.charAt(0).toUpperCase();
  }
  
  if (lastName) {
    return lastName.charAt(0).toUpperCase();
  }
  
  if (!userId) return "AN"; // Anonymous
  
  // Generate consistent initials from user ID
  const chars = userId.replace(/-/g, '').toUpperCase();
  return chars.slice(0, 2);
};
